export default __webpack_public_path__ + "static/media/delegates__cards-list-item-icon-4.ac9284d0.svg";